import { first } from 'rxjs/operators'

import { DataService, MapProvider } from '@shared/services/data.service'
import { MapCurrentLocationMapboxService } from './map-current-location-mapbox.service'
import { MapCurrentLocationGoogleMapsService } from './map-current-location-google-maps.service'

export function mapCurrentLocationFactory(dataService: DataService) {
  let mapProvider: MapProvider
  dataService.mapProvider$.pipe(first()).subscribe((provider) => (mapProvider = provider))

  if (mapProvider === MapProvider.Mapbox) return new MapCurrentLocationMapboxService()
  return new MapCurrentLocationGoogleMapsService()
}
